import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { t } from 'i18next';
import type { FC } from 'react';

import { WavelloIcon } from 'assets/svg';
import theme from 'features/theme/theme';

export const WavelloCallTitle: FC = () => {
  return (
    <Wrapper>
      <WavelloIcon />
      <Typography
        variant='textLargeMedium'
        color={theme.palette.grey[50]}
        ml={4}
      >
        {t('wavello.title')}
      </Typography>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;
